import { IPersonaProps } from '@fluentui/react';

// Helper function to get text from persona
export function getTextFromItem(persona: IPersonaProps): string {
    return persona.text || '';
}
